import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Button} from '@guestapp/ui';
import {PATHS} from 'Routes';
import {usePath} from 'hooks';
import styles from './styled.module.css';

type Props = {
  onGoToKeyCards?: () => void;
};
function CompletePrintedCardContent({onGoToKeyCards}: Props) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  return (
    <>
      <div>
        <div className={styles.title}>{t('your_keys_are_ready')}</div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          label={t('go_to_home')}
          outlined
          onClick={() => {
            navigate(getFullPath(PATHS.home));
          }}
        />
        <Button label={t('go_to_keycards')} outlined onClick={onGoToKeyCards} />
      </div>
    </>
  );
}

export {CompletePrintedCardContent};
